
import magnificPopup from 'magnific-popup';

if($('.popup-youtube').length) {
  
   $('.popup-youtube').magnificPopup({
    type: 'iframe',
    removalDelay: 500,
    iframe: {
      markup: '<div class="mfp-iframe-scaler">'+
                '<div class="mfp-close"></div>'+
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                      '</div>',
      patterns: {
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?rel=0&autoplay=0&modestbranding=0&showinfo=0'
          }
        },
      srcAction: 'iframe_src',
      },
  });
};